import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { AFTER_INVOICE_PAID, APIManager, BuyType, DeductionType, FlowDataRule, InvoicePage, InvoiceService, NotificationService, RouterBuyType, ServiceService, User, UsersService, WalletsService } from '@flashvpn-io/web-core';
import { BillingCycles, defaultBillingCycles, Invoice, Service } from '@flashvpn-io/web-core';
import { WebUIService } from '../../web-ui.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  // @ViewChild('trigger', { read: MatMenuTrigger }) trigger?: MatMenuTrigger;
  // @ViewChild('loadBottonComponent') loadBottonComponent: LoadBottonComponent;
  public service: Service | null = null;
  // public services: Service[];
  // public invoice: Invoice;
  // public apps: string[];
  public total?: number = 0;
  public displayedColumns: string[] = ['description', 'datepaid', 'paymentmethod', 'total'];
  public submitted = false;
  public loading = false;
  public btnLoading = false;
  public nonServices = false;
  public invoices: Invoice[] = [];
  public invoiceLoading = false;
  public paginator = {
    length: 0,
    pageSize: 3,
    pageIndex: 0,
  };
  public currentDeduction: string = '';
  public discountCode: string = '';
  public billingCycles: BillingCycles[] = defaultBillingCycles;

  public flowdataRule: FlowDataRule[] = [];

  // public systemCollection: string[] = ['Windows', 'macOS', 'Android', 'iOS'];

  public expiredAt: string = '';
  public user: User | null = null;
  protected deliveryIps = [];

  constructor(
    private http: HttpClient,
    public router: Router,
    private route: ActivatedRoute,
    public webUIService: WebUIService,
    public sanitizer: DomSanitizer,
    public userService: UsersService,
    private ref: ChangeDetectorRef,
    private notificationService: NotificationService,
    public walletService: WalletsService,
    // public dialogsService: DialogsService,
    // public dialog: MatDialog,
    private apiManager: APIManager,
    // private paymentService: PaymentService,
    // private globalSubscription: GlobalSubscriptionService,
    private invoiceService: InvoiceService,
    private serviceService: ServiceService,
  ) {
    this.notificationService.register(AFTER_INVOICE_PAID).subscribe(() => {
      this.serviceService.refreshServiceInfo();
    });
  }


  // 判断系统
  // OnGetOS() {
  //   const agent = navigator.userAgent.toLowerCase();
  //   const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  //   const MAC =
  //     /macintosh|mac os x/i.test(navigator.userAgent) && !window.MSStream;
  //   const android = /Android/.test(navigator.userAgent) && !window.MSStream;

  //   if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
  //     return 'Windows'; // 此处根据需求调整
  //   }
  //   if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
  //     return 'Windows'; // 此处根据需求调整
  //   }
  //   if (iOS) {
  //     return 'iOS';
  //   }
  //   if (MAC) {
  //     return 'macOS';
  //   }
  //   if (android) {
  //     return 'Android';
  //   }
  //   return 'Windows';
  // }

  async ngOnInit() {
    // 识别系统放到第一位
    // const systemItem = this.OnGetOS();
    // const ids = this.systemCollection.indexOf(systemItem);
    // this.systemCollection.splice(ids, 1);
    // this.systemCollection.unshift(systemItem);

    await this.reload();
    await this.getInvoices();
    await this.getFlowdataRule();
    this.user = await this.userService.currentUser();
    this.apiManager.getDeliveryIPs().subscribe(ips => {
      this.deliveryIps = ips;
    })

    // this.paymentService.register(PAYMENT_SUBMIT).subscribe(async () => {
    // });
    // this.paymentService.register(IN_PAYMENT).subscribe(async () => {
    //   this.dialog.closeAll();
    //   await this.router.navigate(['payment-status'], { queryParams: { ..._, status: IN_PAYMENT } });
    // });
    // this.paymentService.register(PAYMENT_SUCCESS).subscribe(async () => {
    //   this.dialog.closeAll();
    //   await this.router.navigate(['payment-status'], { queryParams: { ..._, status: PAYMENT_SUCCESS } });
    // });
    // this.paymentService.register(PAYMENT_FAILURE).subscribe(async () => {
    //   this.dialog.closeAll();
    //   await this.router.navigate(['payment-status'], { queryParams: { ..._, status: PAYMENT_FAILURE } });
    // });
    // this.notificationService.register(WINDOW_SRCOLL).subscribe(async () => {
    //   if (this.dialogsService.isMobile() || window.innerWidth <= 599) {
    //     this.invoiceLoading = true;
    //     const paginator = this.paginator;
    //     paginator.pageIndex++;
    //     this.paginator = { ...paginator };
    //     await this.getInvoices();
    //   }
    // });
  }

  // reload from api
  async reload() {
    this.loading = true;
    try {
      this.serviceService.currentService$.subscribe({
        next: (service) => {
          if (service) {
            this.service = service;
            this.expiredAt = new Date(service.nextduedate).toLocaleString();
          } else {
            this.nonServices = true;
          }
        },
        error: (error) => {
          console.error('Error getting service:', error);
          this.nonServices = true;
        }
      });

      this.loading = false;

      if (this.service && this.service.isDue()) {
        this.nonServices = true;
        // this.appService.snackUp(this.appService.translate('ServiceExpired'));
        return;
      }
    } catch (err) {
      this.loading = false;
      this.nonServices = true;
      // this.appService.snackUp(err?.error?.message);
    }
  }

  async goToPaymentMethods() {
    this.loading = true
    // check the invoice
    let invoice = await this.getLatestInvoice(BuyType.SERVICE)
    if (invoice) {
      // this.openInvoicePayDialog(invoice.id, BuyType.SERVICE, this.currentDeduction)
    } else {
      // this.globalSubscription.$routeIsReuse.next({ field: 'payment-methods', value: true });
      await this.router.navigate([`payment-methods/${RouterBuyType.SERVICE}`]);
      const buyService = {
        title: '购买服务',
        rechargeList: this.billingCycles,
        buyType: BuyType.SERVICE.valueOf(),
        service: this.service,
      };
      // this.paymentService.post(DESHBOARD_SEND_DATA, buyService);
    }
  }

  async getInvoices() {
    this.invoiceLoading = true;
    this.invoiceService
      .refreshInvoiceInfo({
        limitnum: 3,
        limitstart: 0,
        orderby: "datepaid",
        order: "descend",
        status: "Paid",
      })
      .subscribe(
        (data: InvoicePage) => {
          this.invoices.push(...data.invoices as unknown as Invoice[]);
          this.total = data.total;
          this.invoiceLoading = false;
          if (this.invoices.length === 0 || (data.invoices as unknown as Invoice[]).length === 0 || this.invoices.length === data.total) {
            this.invoiceLoading = false;
          }
        },
        (error) => {
          console.error("Error fetching invoices:", error);
          this.invoiceLoading = false;
        }
      );
  }

  pageChange(pageInfo: { length: number; pageSize: number; pageIndex: number; }) {
    this.paginator = { ...pageInfo };
    this.getInvoices();
  }

  getFlowdataRule() {
    this.apiManager.getFlowdataRule()
      .subscribe(flowdataRule => {
        this.flowdataRule = flowdataRule;
      }, error => {
        this.webUIService.snackUp(error?.error?.message);
      });
  }

  async goToFlowData() {
    this.loading = true
    let invoice = await this.getLatestInvoice(BuyType.FLOWDATA)
    if (invoice) {
      // this.openInvoicePayDialog(invoice.id, BuyType.FLOWDATA, this.currentDeduction)
    } else {
      // this.globalSubscription.$routeIsReuse.next({ field: 'payment-methods', value: true });
      await this.router.navigate([`payment-methods/${RouterBuyType.FLOWDATA}`]);
      const buyService = {
        title: '购买补充包',
        rechargeList: this.flowdataRule,
        buyType: BuyType.FLOWDATA.valueOf(),
        eDate: this.service?.resetDate,
        service: this.service,
      };
      // this.paymentService.post(DESHBOARD_SEND_DATA, buyService);
    }
  }

  async goToSubscription() {
    await this.router.navigate(['subscription']);
  }

  async getLatestInvoice(type: BuyType) {
    if (!this.service) {
      return undefined
    }

    try {
      let invoice
      if (type === BuyType.SERVICE) {
        invoice = await this.apiManager.fetchLatestInvoice(this.service).toPromise();
      } else if (type === BuyType.FLOWDATA) {
        invoice = await this.apiManager.fetchLatestFlowInvoice(this.service).toPromise();
      } else {
        return undefined
      }
      if (invoice && invoice.items && invoice.items.length > 1) {
        const deductionItems = invoice.items.filter(i => i.description.includes('Deduction'));
        if (deductionItems.length > 0) {
          switch (deductionItems[0].description.split(' ')[0]) {
            case 'Coupon': this.currentDeduction = DeductionType.voucher; break;
            case 'Code':
              this.currentDeduction = DeductionType.discount_code;
              this.discountCode = deductionItems[0].description.split(' ')[2]
              break;
            default: this.currentDeduction = DeductionType.balance;
          }
          return invoice
        }
      }
    } catch (e) {
      console.log(e)
      // if (e.error.error === "NoInvoiceWasCreated") {
      //   return undefined
      // }
    }
    return undefined
  }

  // goToHelps(type: string, code: string) {
  //   const articles = this.helpsArticles.attributes.results;
  //   const urlItems = articles.filter((item: { platform: string; }) => item.platform.toLowerCase() === type.toLowerCase());
  //   const urlItem = urlItems.find((item: { title: string; }) => item?.title?.toLowerCase().indexOf(code.toLowerCase()) > -1);
  //   if (urlItem) {
  //     this.router.navigate([`/helps/article/${urlItem.id}`]);
  //   }
  // }

  // openInvoicePayDialog(id: number, buyType: BuyType, currentDeduction: string) {
  //   // if (this.dialogsService.isMobile() || window.innerWidth <= 599) {
  //   //   this.router.navigate(['select-voucher']);
  //   // } else {
  //   this.loading = false
  //   this.dialogsService.openDialog('invoice-check-dialog', { invoiceId: id, buyType, currentDeduction, discountCode: this.discountCode });
  //   // }
  // }

}